import API from "./API";
// import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                // Alert.warning("Λογαριασμός", "Έχεις αποσυνδεθεί από τον λογαριασμό σου!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
        settingsLoad: () => API.GET('settings'),
        settingsEdit: (data) => API.POST(`settings/edit`, data),
        collect: () => API.GET('collect'),
        testNotification: (data) => API.POST('test-notification', data),
    },

    vehicleType: {
        index: () => API.GET('vehicle-types'),
        details: (id) => API.GET(`vehicle-type/${id}/details`),
        create: (data) => API.POST('vehicle-type/create', data),
        edit: (data) => API.POST(`vehicle-type/edit`, data),
        delete: (id) => API.POST('vehicle-type/delete', {id}),
    },

    transporter: {
        index: (data) => API.POST('transporters', data),
        details: (id) => API.GET(`transporter/${id}/details`),
        create: (data) => API.POST('transporter/create', data),
        edit: (data) => API.POST(`transporter/edit`, data),
        delete: (id) => API.POST('transporter/delete', {id}),
    },

    vehicle: {
        index: (data) => API.POST('vehicles', data),
        search: (data) => API.POST('vehicle/search', data),
        details: (id) => API.GET(`vehicle/${id}/details`),
        create: (data) => API.POST('vehicle/create', data),
        edit: (data) => API.POST(`vehicle/edit`, data),
        delete: (id) => API.POST('vehicle/delete', {id}),
        editDrivers: (data) => API.POST(`vehicle/edit-drivers`, data),
    },

    driver: {
        index: (data) => API.POST('drivers', data),
        details: (id) => API.GET(`driver/${id}/details`),
        create: (data) => API.POST('driver/create', data),
        edit: (data) => API.POST(`driver/edit`, data),
        delete: (id) => API.POST('driver/delete', {id}),
    },

    account: {
        index: (data) => API.POST('accounts', data),
        details: (id) => API.GET(`account/${id}/details`),
        create: (data) => API.POST('account/create', data),
        edit: (data) => API.POST(`account/edit`, data),
        delete: (id) => API.POST('account/delete', {id}),
        editHotels: (data) => API.POST(`account/edit-hotels`, data),
    },

    hotel: {
        index: (data) => API.POST('hotels', data),
        // details: (id) => API.GET(`hotel/${id}/details`),
        details: (data) => API.POST(`hotel/${data.id}/details`, {account_id: data.account_id}),
        create: (data) => API.POST('hotel/create', data),
        edit: (data) => API.POST(`hotel/edit`, data),
        delete: (id) => API.POST('hotel/delete', {id}),
        editDepartments: (data) => API.POST(`hotel/edit-departments`, data),
    },

    department: {
        initialize: () => API.GET('department/initialize'),
        index: (data) => API.POST('departments', data),
        details: (id) => API.GET(`department/${id}/details`),
        create: (data) => API.POST('department/create', data),
        edit: (data) => API.POST(`department/edit`, data),
        delete: (id) => API.POST('department/delete', {id}),
        editHotels: (data) => API.POST(`department/edit-hotels`, data),
        editUsers: (data) => API.POST(`department/edit-users`, data),
    },

    user: {
        index: (data) => API.POST('users', data),
        details: (id) => API.GET(`user/${id}/details`),
        create: (data) => API.POST('user/create', data),
        edit: (data) => API.POST(`user/edit`, data),
        delete: (id) => API.POST('user/delete', {id}),
        toggleNotificationState: (id) => API.POST('user/toggle-notification-state', {id}),
    },

    tour: {
        initialize: () => API.GET('tour/initialize'),
        index: (data) => API.POST('tours', data),
        details: (id) => API.GET(`tour/${id}/details`),
        create: (data) => API.POST('tour/create', data),
        edit: (data) => API.POST(`tour/edit`, data),
        delete: (id) => API.POST('tour/delete', {id}),
        uploadImage: (data) => API.UPLOAD(`tour/image`, data.data, data.blob),
    },

    transfer: {
        initialize: () => API.GET('transfer/initialize'),
        index: (data) => API.POST('transfers', data),
        details: (id) => API.GET(`transfer/${id}/details`),
        create: (data) => API.POST('transfer/create', data),
        edit: (data) => API.POST(`transfer/edit`, data),
        delete: (id) => API.POST('transfer/delete', {id}),

        monthTransfers: (data) => API.POST('calendar/month-transfers', data),
        dayTransfers: (data) => API.POST('calendar/day-transfers', data),

        send_notification_email: (data) => API.POST(`transfer/send-notification-mail`, data),
    },

    localTransfer: {
        initialize: () => API.GET('local/initialize'),
        index: (data) => API.POST('locals', data),
        details: (id) => API.GET(`local/${id}/details`),
        create: (data) => API.POST('local/create', data),
        edit: (data) => API.POST(`local/edit`, data),
        delete: (id) => API.POST('local/delete', {id}),
        getPrice: (data) => API.POST('local/get-price', data),
        getTaxiDriver: (id) => API.POST('local/get-taxi-driver', {id}),
    },

    taxi: {
        index: (data) => API.POST('taxis', data),
        details: (id) => API.GET(`taxi/${id}/details`),
        create: (data) => API.POST('taxi/create', data),
        edit: (data) => API.POST(`taxi/edit`, data),
        delete: (id) => API.POST('taxi/delete', {id}),
    },

    location: {
        index: (data) => API.POST('locations', data),
        details: (id) => API.GET(`location/${id}/details`),
        create: (data) => API.POST('location/create', data),
        edit: (data) => API.POST(`location/edit`, data),
        delete: (id) => API.POST('location/delete', {id}),
        editOrder: (data) => API.POST('location/edit-order', data),
        loadLocalPrices: (id) => API.GET(`location/${id}/local-prices`),
        editLocalPrice: (data) => API.POST(`location/edit-local-price`, data),
        loadLocationPrices: (id) => API.GET(`location/${id}/transfer-prices`),
        editLocationPrice: (data) => API.POST(`location/edit-transfer-prices`, data),
    },

    report: {
        initialize: () => API.GET('report/initialize'),
        transporter: (data) => API.POST('report/transporter', data),
        transporterDetailed: (data) => API.POST('report/transporter-detailed', data),
        account: (data) => API.POST('report/account', data),
        accountInvoices: (data) => API.POST('report/account-invoices', data),
        accountTransporter: (data) => API.POST('report/account-transporter', data),
        department: (data) => API.POST('report/department', data),
        absorption: (data) => API.POST('report/absorption', data),

        export: (data) => API.GET('report/export', data),
    },

    sms: {
        index: (data) => API.POST('sms', data),
    },

    shift: {
        index: (data) => API.POST('shifts', data),
        initialize: () => API.GET('shift/initialize'),
        details: (id) => API.GET(`shift/${id}/details`),
        create: (data) => API.POST('shift/create', data),
        edit: (data) => API.POST(`shift/edit`, data),
        delete: (id) => API.POST('shift/delete', {id}),
        report: (data) => API.POST('shifts/report', data),
    },

    reservation: {
        index: (data) => API.POST('reservations', data),
        details: (id) => API.GET(`reservation/${id}/details`),
        edit: (data) => API.POST(`reservation/edit`, data),
        delete: (id) => API.POST('reservation/delete', {id}),
        concert_to_transfer: (data) => API.bookPOST(data.link_code, `reservation/to-transfer`, {hash: data.hash}),
        // concert_to_transfer: (data) => API.bookPOST(data.link_code, `reservation/to-transfer`, {hash: data.hash}),
        route_to_transfer: (data) => API.POST(`reservation/route-to-transfer`, data),
        send_payment_mail: (data) => API.bookPOST(data.link_code, `reservation/send-payment-mail`, {hash: data.hash}),
        report: (data) => API.POST('reservations-report', data),
    },

    offer: {
        index: (data) => API.POST('offers', data),
        details: (id) => API.GET(`offer/${id}/details`),
        create: (data) => API.POST('offer/create', data),
        edit: (data) => API.POST(`offer/edit`, data),
        delete: (id) => API.POST('offer/delete', {id}),
        editOrder: (data) => API.POST('offer/edit-order', data),
    },
};

export default R;
export {mm as requestingStore};